import {combineReducers} from 'redux';
import Reducer from './Reducer';
import LocationReducer from './location-reducer';


// take object as parameter
export default combineReducers({
    RootReducer: Reducer,
    Settings: LocationReducer

})



// WEBPACK FOOTER //
// ./src/store/reducers/index.js